/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DomesticV2BookingsIdCicoCheckInGet200Response } from '../models';
// @ts-ignore
import { DomesticV2BookingsIdCicoCheckInGetRequest } from '../models';
// @ts-ignore
import { DomesticV2BookingsIdCicoCheckOutGetRequest } from '../models';
// @ts-ignore
import { DomesticV2CicosIdPostGetRequest } from '../models';
// @ts-ignore
import { DomesticV2CicosIdPreGetRequest } from '../models';
/**
 * CicoApi - axios parameter creator
 * @export
 */
export const CicoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check-in PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckInGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckInGet', 'id', id)
            const localVarPath = `/domestic/v2/bookings/{id}/cico/check_in`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check-in a booking before onboarding. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckInGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckInPost: async (id: string, body: DomesticV2BookingsIdCicoCheckInGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckInPost', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckInPost', 'body', body)
            const localVarPath = `/domestic/v2/bookings/{id}/cico/check_in`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check-out PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckOutGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckOutGet', 'id', id)
            const localVarPath = `/domestic/v2/bookings/{id}/cico/check_out`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check-out a booking after the trip is completed. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckOutGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckOutPost: async (id: string, body: DomesticV2BookingsIdCicoCheckOutGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckOutPost', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('domesticV2BookingsIdCicoCheckOutPost', 'body', body)
            const localVarPath = `/domestic/v2/bookings/{id}/cico/check_out`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cico flow
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdGet', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * description
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPostGet', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/post`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostHead: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPostHead', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/post`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Post Rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPostGetRequest} [cicoRequest] To submit a Post Rental Checkout for a booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostPost: async (id: string, cicoRequest?: DomesticV2CicosIdPostGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPostPost', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/post`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cicoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPreGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPreGet', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/pre`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPreHead: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPreHead', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/pre`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a pre-rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPreGetRequest} [cicoRequest] To submit a pre Checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPrePost: async (id: string, cicoRequest?: DomesticV2CicosIdPreGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2CicosIdPrePost', 'id', id)
            const localVarPath = `/domestic/v2/cicos/{id}/pre`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cicoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CicoApi - functional programming interface
 * @export
 */
export const CicoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CicoApiAxiosParamCreator(configuration)
    return {
        /**
         * Check-in PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsIdCicoCheckInGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsIdCicoCheckInGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check-in a booking before onboarding. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckInGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsIdCicoCheckInPost(id: string, body: DomesticV2BookingsIdCicoCheckInGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsIdCicoCheckInPost(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check-out PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsIdCicoCheckOutGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsIdCicoCheckOutGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check-out a booking after the trip is completed. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckOutGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsIdCicoCheckOutPost(id: string, body: DomesticV2BookingsIdCicoCheckOutGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsIdCicoCheckOutPost(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cico flow
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * description
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPostGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPostGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPostHead(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPostHead(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a Post Rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPostGetRequest} [cicoRequest] To submit a Post Rental Checkout for a booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPostPost(id: string, cicoRequest?: DomesticV2CicosIdPostGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPostPost(id, cicoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPreGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPreGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPreHead(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPreHead(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a pre-rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPreGetRequest} [cicoRequest] To submit a pre Checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2CicosIdPrePost(id: string, cicoRequest?: DomesticV2CicosIdPreGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2CicosIdPrePost(id, cicoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CicoApi - factory interface
 * @export
 */
export const CicoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CicoApiFp(configuration)
    return {
        /**
         * Check-in PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckInGet(id: string, options?: any): AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response> {
            return localVarFp.domesticV2BookingsIdCicoCheckInGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Check-in a booking before onboarding. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckInGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckInPost(id: string, body: DomesticV2BookingsIdCicoCheckInGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2BookingsIdCicoCheckInPost(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Check-out PDF location
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckOutGet(id: string, options?: any): AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response> {
            return localVarFp.domesticV2BookingsIdCicoCheckOutGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Check-out a booking after the trip is completed. It\'s currently working for Florida flow only.
         * @param {string} id Booking ID
         * @param {DomesticV2BookingsIdCicoCheckOutGetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsIdCicoCheckOutPost(id: string, body: DomesticV2BookingsIdCicoCheckOutGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2BookingsIdCicoCheckOutPost(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Cico flow
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdGet(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.domesticV2CicosIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * description
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPostGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostHead(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPostHead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Post Rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPostGetRequest} [cicoRequest] To submit a Post Rental Checkout for a booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPostPost(id: string, cicoRequest?: DomesticV2CicosIdPostGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPostPost(id, cicoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPreGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPreGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Booking ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPreHead(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPreHead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a pre-rental checkout for a booking
         * @param {string} id Booking ID
         * @param {DomesticV2CicosIdPreGetRequest} [cicoRequest] To submit a pre Checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2CicosIdPrePost(id: string, cicoRequest?: DomesticV2CicosIdPreGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2CicosIdPrePost(id, cicoRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CicoApi - interface
 * @export
 * @interface CicoApi
 */
export interface CicoApiInterface {
    /**
     * Check-in PDF location
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2BookingsIdCicoCheckInGet(id: string, options?: AxiosRequestConfig): AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response>;

    /**
     * Check-in a booking before onboarding. It\'s currently working for Florida flow only.
     * @param {string} id Booking ID
     * @param {DomesticV2BookingsIdCicoCheckInGetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2BookingsIdCicoCheckInPost(id: string, body: DomesticV2BookingsIdCicoCheckInGetRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Check-out PDF location
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2BookingsIdCicoCheckOutGet(id: string, options?: AxiosRequestConfig): AxiosPromise<DomesticV2BookingsIdCicoCheckInGet200Response>;

    /**
     * Check-out a booking after the trip is completed. It\'s currently working for Florida flow only.
     * @param {string} id Booking ID
     * @param {DomesticV2BookingsIdCicoCheckOutGetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2BookingsIdCicoCheckOutPost(id: string, body: DomesticV2BookingsIdCicoCheckOutGetRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Cico flow
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdGet(id: string, options?: AxiosRequestConfig): AxiosPromise<object>;

    /**
     * description
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPostGet(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPostHead(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create a Post Rental checkout for a booking
     * @param {string} id Booking ID
     * @param {DomesticV2CicosIdPostGetRequest} [cicoRequest] To submit a Post Rental Checkout for a booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPostPost(id: string, cicoRequest?: DomesticV2CicosIdPostGetRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPreGet(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPreHead(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create a pre-rental checkout for a booking
     * @param {string} id Booking ID
     * @param {DomesticV2CicosIdPreGetRequest} [cicoRequest] To submit a pre Checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApiInterface
     */
    domesticV2CicosIdPrePost(id: string, cicoRequest?: DomesticV2CicosIdPreGetRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CicoApi - object-oriented interface
 * @export
 * @class CicoApi
 * @extends {BaseAPI}
 */
export class CicoApi extends BaseAPI implements CicoApiInterface {
    /**
     * Check-in PDF location
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2BookingsIdCicoCheckInGet(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2BookingsIdCicoCheckInGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check-in a booking before onboarding. It\'s currently working for Florida flow only.
     * @param {string} id Booking ID
     * @param {DomesticV2BookingsIdCicoCheckInGetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2BookingsIdCicoCheckInPost(id: string, body: DomesticV2BookingsIdCicoCheckInGetRequest, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2BookingsIdCicoCheckInPost(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check-out PDF location
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2BookingsIdCicoCheckOutGet(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2BookingsIdCicoCheckOutGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check-out a booking after the trip is completed. It\'s currently working for Florida flow only.
     * @param {string} id Booking ID
     * @param {DomesticV2BookingsIdCicoCheckOutGetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2BookingsIdCicoCheckOutPost(id: string, body: DomesticV2BookingsIdCicoCheckOutGetRequest, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2BookingsIdCicoCheckOutPost(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cico flow
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdGet(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * description
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPostGet(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPostGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPostHead(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPostHead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Post Rental checkout for a booking
     * @param {string} id Booking ID
     * @param {DomesticV2CicosIdPostGetRequest} [cicoRequest] To submit a Post Rental Checkout for a booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPostPost(id: string, cicoRequest?: DomesticV2CicosIdPostGetRequest, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPostPost(id, cicoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPreGet(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPreGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Booking ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPreHead(id: string, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPreHead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a pre-rental checkout for a booking
     * @param {string} id Booking ID
     * @param {DomesticV2CicosIdPreGetRequest} [cicoRequest] To submit a pre Checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CicoApi
     */
    public domesticV2CicosIdPrePost(id: string, cicoRequest?: DomesticV2CicosIdPreGetRequest, options?: AxiosRequestConfig) {
        return CicoApiFp(this.configuration).domesticV2CicosIdPrePost(id, cicoRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
